import bunyan from 'bunyan'
import { canUseDom } from '@sainsburys-tech/boltui-utils'

const createLoggerInstance = (name) => {
  return bunyan.createLogger({ name })
}

export default (type, name, responseData = '', msg = '') =>
  !canUseDom() && createLoggerInstance(name)[type](responseData, msg)
